/**
 * Sdílené výchozí hodnoty ACM control portů pro UI formuláře a placeholdery.
 *
 * Toto NEJSOU adresy, na které dashboard volá — to dělá výhradně MCP proxy
 * (lib/mcp.ts, lib/service-endpoints.ts). Tyhle konstanty slouží jen jako
 * defaultní/ukázkové hodnoty ve formulářích (např. „přidat node" dialog),
 * kde uživatel port sám zadává nebo kde se zobrazuje jako informační text.
 */
export const DEFAULT_API_PORT = 8091;
export const DEFAULT_API_TLS_PORT = 9081;
export const DEFAULT_UI_PORT = 8090;
export const DEFAULT_MCP_PORT = 9082;
export const DEFAULT_AGENT_PORT = 8093;
